export class AnimationFrameRequest{
	handle=0;

	public constructor(
		private func:()=>boolean,
		enabled:boolean,
	){
		if(enabled)
			this.request();
	}

	public dispose(){
		this.cancel();
		this.func=null;
	}

	private request(){
		if(this.func)
			this.handle=requestAnimationFrame(()=>this.run());
	}

	private cancel(){
		cancelAnimationFrame(this.handle);
		this.handle=0;
	}

	private run(){
		this.handle=0;
		if(this.func())
			this.request();
	}

	public get enabled(){
		return !!this.handle;
	}

	public set enabled(v){
		if(this.enabled!==v){
			if(v)
				this.request();
			else
				this.cancel();
		}
	}
}